import React, { Component } from "react";
import "../initialPage/initial.scss";
import { Col, Row, Container, Navbar, NavbarBrand, } from 'bootstrap-4-react';

class HeaderDirectorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    
  }

  componentDidMount() {  }

  render() {
    const { typeHeader, signedIn } = this.props.initState

    if(signedIn.id_usuario === 'wiwi00_adm') {
      return <Navbar light expand="md" sticky={'top'} className="headerPagePos">
          &nbsp;&nbsp;Empresa
      </Navbar>
    }

    return (
      <Navbar light expand="md" sticky={'top'} className="headerPagePos">
        <img alt={"Logo"} src="img/hgapp/logohg.png" className="headerPagePos__logo"
          onClick={(e) => { }} />
          &nbsp;&nbsp;Carnicerías Hermanos Gonzalez
      </Navbar>
    )

    return (
      <div style={{ background: '#b71540', height: 190, overflow: 'hidden', position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1, }} >
        <Container>
          <Row className={'headerDirector__row'}>
            <Col xs={'2'}>
              <img alt={"img"} src={ 'img/hgapp/logohg.png' } className={'headerDirector__profile'} />
            </Col>
            <Col className={'headerDirector__description'}>
              <p>Bienvenido de nuevo,</p>
              <h4>{`${signedIn.nombre} ${signedIn.apellidos}`}</h4>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

};

export default HeaderDirectorPage